import React, { useState, useEffect } from "react";
import CheckCircleSmall from "icons/CheckCircleSmall";
import { CSSTransition } from "react-transition-group";
import TrashButton from "./TrashButton";
import DoneToggleButton from "./DoneToggleButton";

import itemSizes from "constants/sizes.scss";

import store from "glassRedux/store";
import { completeItem } from "shared/itemLists/redux/itemListsSlice";

export default function SwipeOptions(props) {
  const {
    itemType,
    numOptions,
    setIsContainerIn,
    setIsItemMounted,
    setIsItemMarkedUndone,
    isItemMarkedUndone,
    itemId,
    isJustCompleted,
    listType,
    isDue,
    handleTrashClick,
  } = props;
  const [isComplete, setIsComplete] = useState(false);
  const [isIn, setIsIn] = useState(true);

  useEffect(() => {
    if (isJustCompleted) {
      setIsComplete(true);
    }
  }, []);

  useEffect(() => {
    if (isJustCompleted) {
      setIsComplete(true);
    }
  }, [isJustCompleted]);

  function handleEmptyCircleClick() {
    setIsComplete(true);
  }

  function handleCheckCircleClick() {
    setIsItemMarkedUndone(true);
  }

  function handleCompleteBarEntered() {
    setIsIn(false); // begins transition out
    setIsItemMounted(false);
  }

  function handleCompleteBarExited() {
    setIsContainerIn(false);
    store.dispatch(
      completeItem({ isDue, id: itemId, preventPatch: isJustCompleted })
    );
  }

  function width() {
    return Number.parseInt(itemSizes.item_left_margin) * numOptions + "px";
  }

  return (
    <>
      <CSSTransition
        in={isComplete && isIn}
        unmountOnExit
        timeout={300}
        classNames="complete-bar"
        onEntered={handleCompleteBarEntered}
        onExited={handleCompleteBarExited}
      >
        <div className={"complete-bar item " + itemType + " noselect"}>
          <div className="item-prefix">
            <CheckCircleSmall />
          </div>
          <span className="complete-text item-selected-txtstyl">Complete!</span>
        </div>
      </CSSTransition>
      {isIn && (
        <div className={"Swipe-options item " + itemType}>
          <div
            className="swipe-option-button-container"
            style={{ width: width() }}
          >
            <div className="swipe-option">
              {
                <DoneToggleButton
                  {...{ handleEmptyCircleClick, handleCheckCircleClick }}
                  disabled={
                    itemType === "calendar_note" ||
                    itemType === "continuing_calendar_note"
                  }
                  isDone={listType === "Done" && !isItemMarkedUndone}
                  isRed={listType === "Act" && isDue}
                />
              }
            </div>
            {numOptions >= itemSizes.num_options && (
              <div className="swipe-option">
                <TrashButton handleTrashClick={handleTrashClick} />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
